import { Avatar, Grid } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import useGetModule from "../../../api-manage/hooks/react-query/useGetModule";
import { getLanguage } from "../../../helper-functions/getLanguage";
import { setModules } from "../../../redux/slices/configData";
import {
  CustomBoxFullWidth,
  CustomStackFullWidth,
} from "../../../styled-components/CustomStyles.style";
import CustomImageContainer from "../../CustomImageContainer";
import AddressReselect from "../top-navbar/address-reselect/AddressReselect";
import DrawerMenu from "../top-navbar/drawer-menu/DrawerMenu";
import MobileModuleSelection from "./mobile-module-select";
import CallToAdmin from "../../CallToAdmin";
import ThemeSwitches from "../top-navbar/ThemeSwitches";

const ModuleWiseNav = (props) => {
  const { router, configData, token, setToggled, location } = props;

  const { modules } = useSelector((state) => state.configData);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { data, refetch } = useGetModule();
  const { profileInfo } = useSelector((state) => state.profileInfo);
  const socialPhotoUrl =
    typeof window !== "undefined"
      ? localStorage.getItem("social_photo_url")
      : null;
  const profileImageUrl = profileInfo?.image
    ? `${configData?.base_urls?.customer_image_url}/${profileInfo?.image}`
    : socialPhotoUrl || undefined;
  const businessLogo = `${configData?.base_urls?.business_logo_url}/${configData?.logo}`;
  const lanDirection = getLanguage();
  const dispatch = useDispatch();
  useEffect(() => {
    if (modules?.length === 0) {
      refetch();
    }
  }, [modules, refetch]);
  
  useEffect(() => {
    if (data?.length > 0) {
      dispatch(setModules(data));
    }
  }, [data, dispatch]);
  const handleProfileClick = () => {
    if (token) {
      router.push(
        { pathname: "/profile", query: { page: "profile-settings" } },
        undefined,
        { shallow: true }
      );
    } else {
      router.push("/auth/sign-in", undefined, { shallow: true });
    }
  };

  const handleFlexendSide = () => (
    <CustomStackFullWidth
      direction="row"
      justifyContent="flex-end"
      alignItems="center"
      spacing={0.5}
      sx={{ minWidth: 'fit-content', flexShrink: 0 }}
    >
      <Box sx={{ minWidth: 'fit-content' }}>
        <ThemeSwitches noText={true} />
      </Box>
      <Box sx={{ minWidth: 'fit-content' }}>
        <CallToAdmin configData={configData} />
      </Box>
      <Avatar
        src={profileImageUrl}
        sx={{ width: 18, height: 18, cursor: "pointer", minWidth: 18, flexShrink: 0 }}
        onClick={handleProfileClick}
      />
      <Box sx={{ minWidth: 'fit-content' }}>
        <DrawerMenu
          setToggled={setToggled}
          setOpenDrawer={setOpenDrawer}
          openDrawer={openDrawer}
        />
      </Box>
    </CustomStackFullWidth>
  );
  const handleIconClick = () => {
    if (location) {
      router.push("/home");
    } else {
      router.push("/");
    }
  };
  const getIcon = () => (
    <Box
      onClick={handleIconClick}
      sx={{
        height: { xs: "70px", sm: "60px" }, // Significantly increased height to prevent logo cutting
        width: { xs: "30vw", sm: "35px" }, // Increased width to prevent horizontal cutting
        minWidth: { xs: "30vw", sm: "35px" },
        maxWidth: { xs: "30vw", sm: "35px" },
        position: "relative",
        cursor: "pointer",
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", sm: "flex-start" }, // Center align for mobile, left align for desktop
        overflow: "visible",
        padding: { xs: "2px", sm: "2px" }, // Reduced padding to give more space for logo
      }}
    >
      <CustomImageContainer
        src={businessLogo}
        alt="Business Logo"
        height="100%"
        width="100%"
        objectFit="contain"
      />
    </Box>
  );
  return (
    <CustomStackFullWidth>
      {!!modules && (
        <Grid container alignItems="center" spacing={1} sx={{ minHeight: { xs: '75px', sm: '65px' } }}>
          <Grid
            item
            xs={12}
            sm={10}
            align={
              lanDirection
                ? lanDirection === "ltr"
                  ? "left"
                  : "right"
                : "left"
            }
            container
          >
            <CustomBoxFullWidth>
              <Grid
                container
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
                sx={{ flexWrap: { xs: 'wrap', sm: 'nowrap' } }}
              >
                <Grid 
                  item 
                  xs={12} 
                  sm={1} 
                  sx={{ 
                    minWidth: 'fit-content',
                    maxWidth: { xs: 'none', sm: 'none' },
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start', // Left align the logo on mobile
                    overflow: 'visible'
                  }}
                >
                  {router.pathname === "/home" && !router.query.search ? (
                    modules.length >= 2 ? (
                      <MobileModuleSelection />
                    ) : (
                      getIcon()
                    )
                  ) : (
                    getIcon()
                  )}
                </Grid>
                {location ? (
                  <Grid 
                    item 
                    xs={12} 
                    sm={11} 
                    sx={{ 
                      minWidth: 0,
                      order: { xs: 2, sm: 0 },
                      width: { xs: '100%', sm: 'auto' }
                    }}
                  >
                    <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <AddressReselect
                        setOpenDrawer={setOpenDrawer}
                        location={location}
                        openDrawer={openDrawer}
                      />
                    </Box>
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={11} sx={{ order: { xs: 2, sm: 0 } }}></Grid>
                )}
              </Grid>
            </CustomBoxFullWidth>
          </Grid>
          <Grid 
            item 
            xs="auto" 
            sm={2} 
            sx={{ 
              minWidth: 'fit-content',
              order: { xs: 1, sm: 0 },
              ml: { xs: 'auto', sm: 0 }
            }}
          >
            {handleFlexendSide()}
          </Grid>
        </Grid>
      )}
    </CustomStackFullWidth>
  );
};

ModuleWiseNav.propTypes = {
  router: PropTypes.object.isRequired,
  configData: PropTypes.object,
  token: PropTypes.string,
  setToggled: PropTypes.func,
  location: PropTypes.string,
};

export default React.memo(ModuleWiseNav);
